'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GridCell = function (_Component) {
  _inherits(GridCell, _Component);

  function GridCell() {
    _classCallCheck(this, GridCell);

    return _possibleConstructorReturn(this, (GridCell.__proto__ || Object.getPrototypeOf(GridCell)).apply(this, arguments));
  }

  _createClass(GridCell, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          direction = _props.direction,
          fill = _props.fill,
          fit = _props.fit,
          full = _props.full,
          none = _props.none,
          width = _props.width,
          shrink = _props.shrink,
          subGrid = _props.subGrid,
          verticalAlign = _props.verticalAlign,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'direction', 'fill', 'fit', 'full', 'none', 'width', 'shrink', 'subGrid', 'verticalAlign']);

      var classes = (0, _classnames3.default)('ax-grid__cell', (_classnames = {}, _defineProperty(_classnames, 'ax-grid__cell--' + verticalAlign, verticalAlign), _defineProperty(_classnames, 'ax-grid__cell--fill', fill === true), _defineProperty(_classnames, 'ax-grid__cell--fit', fit === true), _defineProperty(_classnames, 'ax-grid__cell--full', full === true), _defineProperty(_classnames, 'ax-grid__cell--none', none === true || width), _defineProperty(_classnames, 'ax-grid__cell--shrink', shrink === true), _defineProperty(_classnames, 'ax-grid__cell--fit--' + fit, fit && fit !== true), _defineProperty(_classnames, 'ax-grid__cell--fill--' + fill, fill && fill !== true), _defineProperty(_classnames, 'ax-grid__cell--full--' + full, full && full !== true), _defineProperty(_classnames, 'ax-grid__cell--none--' + none, none && none !== true), _defineProperty(_classnames, 'ax-grid__cell--shrink--' + shrink, shrink && shrink !== true), _defineProperty(_classnames, 'ax-grid__cell--sub-grid', subGrid), _defineProperty(_classnames, 'ax-grid--columns', subGrid && direction === 'column'), _classnames), className);

      var styles = {
        width: width && Math.max(0, Math.min(width, 100)) + '%'
      };

      return _react2.default.createElement(
        _Base2.default,
        _extends({}, rest, { className: classes, style: styles }),
        children
      );
    }
  }]);

  return GridCell;
}(_react.Component);

GridCell.propTypes = {
  children: _propTypes2.default.node,
  /** Class name to be appended to the element */
  className: _propTypes2.default.string,
  /*
  * Controls the direction of the grid cells
  */
  direction: _propTypes2.default.oneOf(['row', 'column']),
  /**
   * Sizes itself according to the size of its contents. This causes the grid
   * to attempt to evenly distribute the cells, but allows cells to increase
   * their width to provide more room for the contents.
   *
   * When a filled cell exceeds the available room (relative to siblings) it
   * will drop onto its own line. Combined with Grids wrapping property, this
   * can controlled not to shrink siblings down.
   *
   * This can be configured to be all of the time or at specific breakpoints.
   */
  fill: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Sizes itself irrespective of its contents. This causes the grid to evenly
   * distribute all children cells. If the grid has wrapping enabled, the cell
   * may drop to a new line when there is no room left.
   *
   * This can be configured to be all of the time or at specific breakpoints.
   */
  fit: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Sizes itself to 100% of the available width within a grid. This causes
   * all other siblings to placed vertically of itself.
   *
   * This can be configured to be all of the time or at specific breakpoints.
   */
  full: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Sizes itself according to the size of its contents, similar to `shrink` it
   * will no increase to any available space but also will not decrease below
   * it's own content size.
   *
   * This can be configured to be all of the time or at specific breakpoints.
   */
  none: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Sizes itself according to the size of its contents, but does not increase
   * to any available width within a grid. This allows all other siblings to
   * consume the available space.
   *
   * This can be configured to be all of the time or at specific breakpoints.
   */
  shrink: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Allows a grid cell function as a flex container itself.
   */
  subGrid: _propTypes2.default.bool,
  /**
   * Vertically aligns itself relative to other cells within a grid.
   */
  verticalAlign: _propTypes2.default.oneOf(['start', 'middle', 'end']),
  /** Percentage width */
  width: _propTypes2.default.number
};
exports.default = GridCell;